import { render, staticRenderFns } from "./viewRoomData.vue?vue&type=template&id=80b6b56c"
import script from "./viewRoomData.vue?vue&type=script&lang=js"
export * from "./viewRoomData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports